import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("ОК")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialog) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialog=false)),
            "max-width": "200"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "justify-center" }, {
                default: _withCtx(() => [
                  (_ctx.dialogSuccess)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        class: "mb-5",
                        color: "success",
                        icon: "mdi-check-circle",
                        size: "32"
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        class: "mb-5",
                        color: "amber-lighten-3",
                        icon: "mdi-close-circle-outline",
                        size: "32"
                      })),
                  _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.dialogText), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "flex-column my-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialog = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (0 && !this.$route.path.includes('/auth'))
        ? (_openBlock(), _createBlock(_component_v_app_bar, {
            key: 0,
            app: "",
            collapse: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.userData ? _ctx.userData.email : 'No auth'), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, { onMsg: _ctx.onMsg }, null, 8, ["onMsg"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}